import { Location } from '@agroone/entities'

/** Converts a `Location` (string coordinates) into the numeric center expected by `MapCoreService.init`. */
export function toMapCenter(location?: Location | null): { latitude: number; longitude: number } | null {
  return location ? { latitude: Number(location.latitude), longitude: Number(location.longitude) } : null
}
